export default __webpack_public_path__ + "static/media/tortoise.570f01cd.jpg";